const ParamsHelper = {
  getParam(name) {
    let url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  addParam(name, value) {
    var url = new URL(window.location.href);
    var query_string = url.search;
    var search_params = new URLSearchParams(query_string);
    search_params.append(name, value);
    url.search = search_params.toString();
    var new_url = url.toString();
    console.log(new_url)
    window.history.pushState({path:new_url},'',new_url);
  },
  editParam(name, value) {
    var url = new URL(window.location.href);
    var query_string = url.search;
    var search_params = new URLSearchParams(query_string);
    search_params.set(name, value);
    url.search = search_params.toString();
    var new_url = url.toString();
    window.history.pushState({path:new_url},'',new_url);
  },
  hasParam(name) {
    var field = name;
    var url = window.location.href;
    if(url.indexOf('?' + field + '=') != -1)
        return true;
    else if(url.indexOf('&' + field + '=') != -1)
        return true;
    return false
  },
}

export default ParamsHelper



// WEBPACK FOOTER //
// ./scripts/helpers/ParamsHelper.js